document.addEventListener('DOMContentLoaded', function () {
    var elms;

    // A - Profile carousels of owners and rides on the About page
    elms = document.getElementsByClassName('profiles-inner');
    for (var i = 0; i < elms.length; i++) {
        new Splide(elms[i], {
            arrowPath: 'm14,35V5l15,15-15,15Z',
            type: 'loop',
            pagination: false
        }).mount();
    }

    // B - Interview carousel at the top of the Media page 
    elms = document.getElementsByClassName('interviews');
    for (var i = 0; i < elms.length; i++) {
        var interviews = new Splide(elms[i], {
            arrowPath: 'm14,35V5l15,15-15,15Z',
            type: 'loop',
            pagination: false,
            gap: '3rem',
            // perPage: 3,
            perMove: 1,
            autoWidth: true,
            focus: 'center',
            isNavigation: true,
            updateOnMove: true,
            flickPower: 200,
            breakpoints: {
                620: {
                    gap: '1rem'
                }
            }
        }).mount();

        interviews.on('inactive', function (slide) {
            if (jQuery(slide.slide).find('.yt-player').data('yt-api')) {
                jQuery(slide.slide).find('.yt-player').data('yt-api').stopVideo();
            }
        });
    }

    // C - Photo Gallery
    elms = document.getElementsByClassName('photo-gallery');
    for (var i = 0; i < elms.length; i++) {
        var main = new Splide(elms[i], {
            arrowPath: 'm14,35V5l15,15-15,15Z',
            // rewind: true,
            type: 'fade',
            pagination: false
        });

        var next = elms[i].nextElementSibling;
        if (next && next.matches('.photo-thumbs')) {
            var thumbs = new Splide(next, {
                arrows: false,
                fixedWidth: 240,
                fixedHeight: 150,
                type: 'loop',
                gap: 10,
                rewind: true,
                pagination: false,
                isNavigation: true,
                updateOnMove: true,
                focus: 'center',
                flickPower: 150,
                breakpoints: {
                    900: {
                        fixedWidth: 120,
                        fixedHeight: 75,
                    },
                },
            });
        }

        if (thumbs) {
            
            main.sync(thumbs);
            main.mount();
            thumbs.mount();
        }
        else {

            main.mount();
        }

    }

    // C - YouTube Gallery
    elms = document.getElementsByClassName('video-gallery');
    for (var i = 0; i < elms.length; i++) {
        var main = new Splide(elms[i], {
            arrowPath: 'm14,35V5l15,15-15,15Z',
            // rewind: true,
            type: 'fade',
            pagination: false
        });

        main.on('inactive', function (slide) {
            if (jQuery(slide.slide).find('.yt-player').data('yt-api')) {
                jQuery(slide.slide).find('.yt-player').data('yt-api').stopVideo();
            }
        });

        var next = elms[i].nextElementSibling;
        if (next && next.matches('.video-thumbs')) {
            var videoThumbs = new Splide(next, {
                arrows: false,
                fixedWidth: 240,
                fixedHeight: 150,
                type: 'loop',
                gap: 10,
                rewind: true,
                pagination: false,
                isNavigation: true,
                updateOnMove: true,
                focus: 'center',
                flickPower: 150,
                breakpoints: {
                    900: {
                        fixedWidth: 120,
                        fixedHeight: 75,
                    },
                },
            });
        }

        if (videoThumbs) {
            
            main.sync(videoThumbs);
            main.mount();
            videoThumbs.mount();
        }
        else {

            main.mount();
        }

    }


    // D - Supplier logos
    elms = document.getElementsByClassName('suppliers-splide');
    for (var i = 0; i < elms.length; i++) {
        var main = new Splide(elms[i], {
            // rewind: true,
            arrows: false,
            fixedWidth: 200,
            fixedHeight: 100,
            breakpoints: {
                700: {
                    fixedWidth: 120,
                    fixedHeight: 75,
                    gap: '3rem'
                },
            },
            type: 'loop',
            drag: 'free',
            focus: 'center',
            gap: '6rem',
            pagination: false,
            autoScroll: {
                speed: 0.5,
            }
        });

        main.mount(window.splide.Extensions);
    }




    ///// YouTube iFrame API for the interview carousel

    // 1. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 2. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    window.onYouTubeIframeAPIReady = function () {
        jQuery('.video-preview').on('click', e => {
            if (jQuery(e.currentTarget).closest('li').hasClass('is-active')) {
                var player = new YT.Player(jQuery(e.currentTarget).find('.yt-player')[0], {
                    height: '390',
                    width: '640',
                    videoId: jQuery(e.currentTarget).find('.yt-player').data('yt-id'),
                    playerVars: {
                        'playsinline': 1,
                        'rel': 0
                    },
                    events: {
                        'onReady': onPlayerReady
                    }
                });

                jQuery(e.currentTarget).find('.yt-player').data('yt-api', player);
            }
        });
    }

    // 3. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
        event.target.playVideo();
    }
});
